import axios from 'axios'

// 格式化更新时间
export const formatUpdateTime = () => {
  const now = new Date()
  const pad = (n) => `${n}`.toString().padStart(2, '0')
  return `${pad(now.getMonth() + 1)}月${pad(now.getDate())}日 ${pad(now.getHours())}点${pad(now.getMinutes())}分`
}

// 获取基金数据
export const fetchFundData = (tab, backendUrl = 'http://127.0.0.1:8080', retryCount = 0) => {
  const maxRetries = 2

  return new Promise((resolve, reject) => {
    axios({
      url: `${backendUrl}/miniprogram/market/data?tab=${tab}`,
      method: 'get',
      timeout: 15000
    })
      .then(response => {
        const payload = (response.data && response.data.data) || response.data || {}
        const columns = payload.columns || []
        const rawRows = payload.rows || []
        const updateTime = payload.updateTime || formatUpdateTime()

        // 处理行数据
        const rows = rawRows.map((row) => {
          const cells = (columns || []).map((col) => {
            const type = col.type || 'text'
            if (type === 'fund') {
              return { type: 'fund', key: col.key }
            }
            if (type === 'premium') {
              return {
                type: 'premium',
                key: col.key,
                value: row.premium,
                className: `${col.className || ''} ${row.premiumClass || ''}`.trim()
              }
            }
            return {
              type,
              key: col.key,
              value: row[col.key],
              className: (col.className || '').trim()
            }
          })
          return { ...row, cells }
        })

        resolve({
          columns,
          rows,
          updateTime
        })
      })
      .catch(error => {
        console.error('API请求失败:', error)
        if (retryCount < maxRetries) {
          console.log(`准备重试 (${retryCount + 1}/${maxRetries})...`)
          setTimeout(() => {
            fetchFundData(tab, backendUrl, retryCount + 1)
              .then(resolve)
              .catch(reject)
          }, 1000 * (retryCount + 1))
        } else {
          // 重试失败后返回空数据
          resolve({
            columns: [],
            rows: [],
            updateTime: formatUpdateTime()
          })
        }
      })
  })
}

